<template>
    <div class="pt-4">
        <h1 v-if="staffRoute">Instellingen {{ $route.params.slug | title('-') }}</h1>
        <vs-card class="mt-6" v-if="staffRoute && can('edit-legal-info')">
            <div slot="header">
                <h2>Legal</h2>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">KVK Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="coc" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">BTW Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="vat" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">IBAN Nummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="iban" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Statutaire naam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="legal_name" />
                </div>
            </div>

        </vs-card>
        <vs-card>
            <div slot="header">
                <h2 v-if="!staffRoute">Standaard</h2>
                <h2 v-if="staffRoute">Instellingen</h2>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Naam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="name" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Slug</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="slug" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Land</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="country" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Provincie/Staat</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="state" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Stad</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="city" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Straatnaam</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="streetname" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Huisnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="housenumber" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Postcode</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="postcode" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="email" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Financieel Email</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="financialemail" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Telefoonnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="phonenumber" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Intern telefoonnummer</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-input class="w-full" type="text" v-model="internalphonenumber" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Gebied</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-select class="w-full" v-model="area">
                        <vs-select-item v-for="item in areas" :key="item" :value="item" :text="item" />
                    </vs-select>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Status</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vs-select class="w-full" v-model="status">
                        <vs-select-item value="0" text="Permanent gesloten" />
                        <vs-select-item value="1" text="Open" />
                        <vs-select-item value="2" text="Gesloten" />
                        <vs-select-item value="3" text="Tijdelijk gesloten" />
                        <vs-select-item value="4" text="Binnenkort beschikbaar" />
                    </vs-select>
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Banner</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="file" ref="banner" v-on:change="handleBannerUpload" />
                </div>
            </div>

            <div class="vx-row mb-6" v-if="staffRoute">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Logo</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="file" ref="logo" v-on:change="handleLogoUpload" />
                </div>
            </div>

        </vs-card>
        <vs-card v-if="staffRoute">
            <div slot="header">
                <h2>Openingstijden</h2>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Maandag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="monday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Dinsdag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="tuesday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Woensdag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="wednesday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Donderdag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="thursday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Vrijdag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="friday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Zaterdag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="saturday" />
                </div>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                    <span class="float-right font-bold">Zondag</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <input class="vs-inputx vs-input--input normal hasValue w-full" type="text" v-mask="'##:##-##:##'" placeholder="10:00-22:30" v-model="sunday" />
                </div>
            </div>

        </vs-card>

        <vs-card v-if="staffRoute">
            <div slot="header">
                <h2>Betaalmethodes</h2>
            </div>

            <div class="vx-row mb-6">
                <div class="vx-col sm:w-2/3 w-full ml-auto" v-for="paymentMethod in availablepaymentMethods" :key="paymentMethod">
                    <label>
                        <input type="checkbox" class="inline-flex" v-model="paymentMethods" :name="paymentMethod.name" :value="paymentMethod.id" />
                        {{ paymentMethod.name}}
                    </label>
                </div>
            </div>
        </vs-card>

        <vs-button @click="saveCompanyInfo" class="w-full">Opslaan</vs-button>
    </div>
</template>

<script>
export default {
    mounted() {
        this.getCompanyInfo(null)
        this.getPaymentMethods()
        this.$events.listen("company-selected", event => {
            this.getCompanyInfo(event)
        });
    },
    data() {
        return {
            area: null,
            coc: null,
            vat: null,
            iban: null,
            name: null,
            slug: null,
            legal_name: null,
            country: null,
            state: null,
            city: null,
            streetname: null,
            housenumber: null,
            postcode: null,
            email: null,
            financialemail: null,
            phonenumber: null,
            internalphonenumber: null,
            service: null,
            status: null,
            package: null,
            banner: null,
            logo: null,
            bannerString: null,
            logoString: null,
            openinghours: [],
            paymentMethods: [],
            availablepaymentMethods: [],
            oldSlug: null,
            areas: [
                'Spijkenisse',
                'Schiedam',
                'Ijsselmonde',
                'Delft'
            ],
            monday: null,
            tuesday: null,
            wednesday: null,
            thursday: null,
            friday: null,
            saturday: null,
            sunday: null,
        }
    },
    computed: {
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    watch: {
        name: function() {
            const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
            const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
            const p = new RegExp(a.split('').join('|'), 'g')
            this.slug = this.name.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '')
        }
    },
    methods: {
        can: function(permission) {
            return this.$can(permission);
        },
        getPaymentMethods: function() {
            this.$http.get('/v1/paymentmethods', {
                headers: {
                    Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
                }
            }).then((response) => {
                this.availablepaymentMethods = response.data
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        },
        getCompanyInfo: function(company) {
            if(company !== null) {
                var url = this.staffRoute ? '/v1/company/'+ company.slug +'/info' : '/v1/company/'+ company.slug +'/info'
            } else  {
                var url = this.staffRoute ? '/v1/company/'+ this.$route.params.slug +'/info' : '/v1/company/'+ this.$route.params.slug +'/info'
            }
            this.$http.get(url).then((response) => {
                this.coc = response.data.chamber_of_commerce_number
                this.vat = response.data.vat_number
                this.area = response.data.area
                this.iban = response.data.bank_account
                this.name = response.data.name
                this.slug = response.data.slug
                this.legal_name = response.data.legal_name
                this.country = response.data.country
                this.state = response.data.state
                this.city = response.data.city
                this.streetname = response.data.streetname
                this.housenumber = response.data.housenumber
                this.postcode = response.data.postal_code
                this.email = response.data.email
                this.financialemail = response.data.finance_email
                this.phonenumber = response.data.phone_number
                this.internalphonenumber = response.data.internal_phone_number
                this.service = response.data.service
                this.status = response.data.status
                this.package = response.data.package_id
                this.bannerString = response.data.banner
                this.logoString = response.data.logo
                this.oldSlug = response.data.slug
                response.data.payment_methods.map(method => {
                    this.paymentMethods.push(method.id);
                })
                response.data.opening_hours.map(hour => {
                    switch (hour.day) {
                        case 1:
                            this.monday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 2:
                            this.tuesday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 3:
                            this.wednesday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 4:
                            this.thursday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 5:
                            this.friday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 6:
                            this.saturday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                        case 7:
                            this.sunday = hour.opening_time.substring(0, 5) + '-' + hour.closing_time.substring(0, 5);
                            break;
                    }
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        },
        saveCompanyInfo: function() {
            let formData = new FormData();

            formData.append('_method', 'PUT');
            formData.append('area', this.area);
            formData.append('banner', this.banner);
            formData.append('logo', this.logo);
            formData.append('chamber_of_commerce_number', this.coc);
            formData.append('vat_number', this.vat);
            formData.append('bank_account', this.iban);
            formData.append('name', this.name);
            formData.append('slug', this.slug != this.oldSlug ? this.slug : this.oldSlug);
            formData.append('legal_name', this.legal_name);
            formData.append('country', this.country);
            formData.append('state', this.state);
            formData.append('city', this.city);
            formData.append('streetname', this.streetname);
            formData.append('housenumber', this.housenumber);
            formData.append('postal_code', this.postcode);
            formData.append('email', this.email);
            formData.append('finance_email', this.financialemail);
            formData.append('phone_number', this.phonenumber);
            formData.append('internal_phone_number', this.internalphonenumber);
            formData.append('service', this.service);
            formData.append('status', this.status);
            formData.append('package', this.package_id);
            formData.append('1', this.monday);
            formData.append('2', this.tuesday);
            formData.append('3', this.wednesday);
            formData.append('4', this.thursday);
            formData.append('5', this.friday);
            formData.append('6', this.saturday);
            formData.append('7', this.sunday);
            formData.append('payment_methods', JSON.stringify(this.paymentMethods));

            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? '/v1/company/'+ this.$route.params.slug +'/info/update' : '/v1/company/'+ this.$route.params.slug +'/info/update'
            this.$http.post(url, formData,
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                console.log(response)
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
                this.getCompanyInfo();
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })
        },
        handleBannerUpload: function() {
            this.banner = this.$refs.banner.files[0];
        },
        handleLogoUpload: function() {
            this.logo = this.$refs.logo.files[0];
        }
    }
}
</script>

<style>

</style>
